export default function async ({ commit }, router) {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('permissions')
  window.localStorage.removeItem('username')
  window.localStorage.removeItem('userId')
  commit('DO_LOGOFF')

  router.replace('/login')
}



// WEBPACK FOOTER //
// ./src/view/login/state/action/DoLogoff.js